import { DropdownDataProps } from 'common/components/Select';

type GenderListProps = DropdownDataProps & {
  tableLabel?: string;
};

export const genderList = [
  {
    label: 'Жінка',
    tableLabel: 'Ж',
    value: 1,
  },
  {
    label: 'Чоловік',
    tableLabel: 'Ч',
    value: 2,
  },
  {
    label: 'Інше',
    tableLabel: 'Інше',
    value: 3,
  },
  {
    label: 'Не хочу вказувати',
    value: 4,
  },
] as GenderListProps[];
